import React, { useEffect, useState } from 'react';
import SvgIcon from '@home/components/SvgIcon';
import TrendCardTips from './TrendCardTips';

import './index.scss';
import CardCommon from '@op/components/CardCommon';
import { getStudioCompetitorRank } from '@op/services';
import { canRequest, useToOpinionPage } from '../utils';
import { useIntl } from 'umi';
import { NO_DATE } from '@op/constants';
export default function TrendCard({
  className,
  title,
  children,
  filter,
  moduleType,
  communityType,
  showRank = true,
  isLeft = false,
  empty = false,
  noJump = false,
  loading = false,
  formatValue,
  isDelay,
  urlKey,
  ...props
}: any) {
  const { formatMessage } = useIntl();
  const [rankList, setRankList] = useState([]);
  const [rank, setRank] = useState(0);

  const setRanks = (data:any) => {
    const { list } = data || {};
    setRankList(list || []);
    setRank(
      list.findIndex(
        (item: any) => item.edition_unified_id === filter.edition_unified_id,
      ),
    );
  };

  function requestRankList() {
    setRankList([]);
    setRank(0);
    const obj = {
      ...filter,
      module_type: moduleType,
    };
    if (communityType) {
      obj.community_type = communityType;
    }
    // 延迟请求，避免跟其他接口并发请求，导致请求时间过长
    // tapd单号：1120427644120661164
    if (isDelay) {
      setTimeout(() => {
        getStudioCompetitorRank(obj).then((data: any) => {
          setRanks(data);
        }).catch(() => {});
      }, 3000);
    }else{
      getStudioCompetitorRank(obj).then((data: any) => {
        setRanks(data);
      }).catch(() => {});
    }
  }

  useEffect(() => {
    if (canRequest(filter) && moduleType && showRank) {
      requestRankList();
    }
  }, [filter, moduleType, communityType, showRank]);

  const { goToOtherPage } = useToOpinionPage({
    filter,
    key: urlKey || title,
    subKey: communityType,
  });

  const canJump = !(empty || noJump || loading);;

  function goOtherPage() {
    canJump && goToOtherPage();
  }

  return (
    <div className={`dbh-trend-card ${className}`}>
      <div className="dbh-trend-card-header">
        <div className="dbh-trend-card-flex" onClick={goOtherPage}>
          <span className="dbh-trend-card-title">
            {formatMessage({ id: title || NO_DATE.EMPTY })}
          </span>
          {canJump && (
            <SvgIcon type="studio-arrow" className="dbh-trend-card-title-icon" />
          )}
        </div>
        { showRank && rankList.length > 0 && (
          <div className="dbh-trend-card-operation">
            {/* rank-1 */}
            <div className={`dbh-trend-card-operation-rank rank-${rank + 1}`}>
              {rank > -1 && <span>{rank + 1}</span>}
              <TrendCardTips
                communityType={communityType}
                // 【测试 Techland专区】舆情页游戏商店过滤星标评论
                // techland gameStore 排行榜浮窗名称更换
                moduleType={filter?.studioid === "techland" ? "game_store_techland" : "game_store"}
                currentRank={rank}
                rankList={rankList}
                isLeft={isLeft}
                formatValue={formatValue}
              />
            </div>
          </div>
        )}
      </div>
      <div className="dbh-trend-card-body">
        <CardCommon {...props} empty={empty} loading={loading} contentCard>
          {children}
        </CardCommon>
      </div>
    </div>
  );
}
